/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-28 15:53:54
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-11 00:19:20
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\AddressWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import get from "lodash/get";
import negate from "lodash/negate";
import { BsyUtils } from "../Utils";

export default class AddressWidgetFilter extends WidgetFilter {
    all(i, a, n) {
        return function (t) {
            var e = !0;
            return i && (e = get(t, "province") === i),
                a && (e = e && get(t, "city") === a),
                e = n ? e && get(t, "district") === n : e
        }
    }
    nin(t, e, i) {
        return negate(this.all(t, e, i))
    }
    empty() {
        return function (t) {
            return BsyUtils.isObjectEmpty(t)
        }
    }
    notEmpty() {
        return negate(this.empty())
    }
}
